import 'babel-polyfill';
import Raven from 'raven-js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import moment from 'moment';
import 'moment/locale/ru';

import './styles/index.scss';

import config from 'config';
import routes from 'routes';
import configureStore from 'redux/configureStore';

import { logPageViewYM, initializeGA, logPageViewGA, initializeFP } from './utils/analytics';
import { YMInitializer } from 'react-yandex-metrika';

const store = configureStore(browserHistory, window.__data);
const history = syncHistoryWithStore(browserHistory, store);

if (config.GOOGLE_COUNTER) {
  initializeGA(config.GOOGLE_COUNTER);
}

if (config.FACEBOOK_PIXEL_COUNTER) {
  initializeFP(config.FACEBOOK_PIXEL_COUNTER);
}


history.listen((location, action) => {
  if (config.GOOGLE_COUNTER) {
    logPageViewGA(config.GOOGLE_COUNTER, location.pathname + location.search);
  }
  if (config.YANDEX_COUNTER) {
    logPageViewYM(location.pathname + location.search);
  }
});

moment.locale('ru');

function init() {
  ReactDOM.render(
    <React.Fragment>
      <YMInitializer accounts={[config.YANDEX_COUNTER]} />
      <Provider store={store}>
        <Router
          history={history}
          routes={routes(store)}
        />
      </Provider>
    </React.Fragment >,
    document.getElementById('root')
  );
}

if (typeof config.SENTRY_DSN === 'string' && config.SENTRY_DSN.length) {
  Raven.config(config.SENTRY_DSN).install();
  window.onunhandledrejection = function (err) {
    console.error('Unhandled Promise Rejection', err.reason);
    Raven.captureException(err.reason);
  };

  try {
    init();
  } catch (e) {
    console.log(e);
    Raven.captureException(e);
  }
} else {
  window.onunhandledrejection = function (err) {
    console.error('Unhandled Promise Rejection', err.reason);
  };

  init();
}



// WEBPACK FOOTER //
// ./src/index.js